<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formUpdateUser" @submit="formSubmit($event, 'updateUser')">
            <CInput
                :isValid="
                    checkIfFormValid({
                        formName: 'updateUser',
                        fieldName: 'email',
                    })
                "
                :value.sync="$v.forms.updateUser.email.$model"
                :label="$t('email')"
                :disabled="true"
            />
            <CInput
                :isValid="
                    checkIfFormValid({
                        formName: 'updateUser',
                        fieldName: 'name',
                    })
                "
                :value.sync="$v.forms.updateUser.name.$model"
                :label="$t('first_name')"
            />
            <CInput
                :isValid="
                    checkIfFormValid({
                        formName: 'updateUser',
                        fieldName: 'custom:last_name',
                    })
                "
                :value.sync="$v.forms.updateUser['custom:last_name'].$model"
                :label="$t('last_name')"
            />
            <PhoneNumberInput
                :isValid="
                    checkIfFormValid({
                        formName: 'updateUser',
                        fieldName: 'phone_number',
                    })
                "
                :value.sync="$v.forms.updateUser.phone_number.$model"
                :label="$t('phone')"
            />

            <CInput
                :isValid="
                    checkIfFormValid({
                        formName: 'updateUser',
                        fieldName: 'custom:postal_code',
                    })
                "
                :value.sync="$v.forms.updateUser['custom:postal_code'].$model"
                :label="$t('postal_code')"
            />

            <CInput
                :value.sync="$v.forms.updateUser['custom:city'].$model"
                :label="$t('city')"
            />

            <CInput
                :value.sync="$v.forms.updateUser['custom:company'].$model"
                :label="$t('company')"
            />

            <SelectCountry
                :label="$t('country')"
                :placeholder="$t('select_an_country')"
                :value.sync="$v.forms.updateUser['custom:country_id'].$model"
            />

            <SelectLanguage
                :value.sync="$v.forms.updateUser['custom:language_id'].$model"
                :label="$t('language')"
                :placeholder="$t('select_an_country')"
            />

            <ButtonLoading type="submit" :block="true" color="primary" :loading="forms.updateUser._loading">
                <span>{{ $t("update_user") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.updateUser._loading">
                {{ $t("update_user") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";

import PhoneNumberInput from "~/components/PhoneNumberInput.vue";
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonLoading from "~/components/ButtonLoading.vue";
export default {
    name: "UpdateUserModal",
    mixins: [formMixin, validationMixin],
    components: {
        PhoneNumberInput,
        SelectCountry,
        SelectLanguage,
        ButtonLoading,
    },
    props: {
        title: String,
        show: Boolean,
        color: String,
        size: String,
        user: Object,
    },

    data() {
        return {
            titleComponent: null,
            showComponent: false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms: {
                updateUser: {
                    name: null,
                    phone_number: null,
                    email: null,
                    "custom:last_name": null,
                    "custom:language_id": null,
                    "custom:country_id": null,
                    "custom:postal_code": null,
                    "custom:city": null,
                    "custom:company": null,
                    _loading: false
                },
            },
        };
    },

    validations: {
        forms: {
            updateUser: {
                email: {
                    required,
                },
                phone_number: {
                    required,
                },
                name: {
                    required,
                },
                "custom:last_name": {
                    required,
                },
                "custom:language_id": {
                },
                "custom:country_id": {
                },
                "custom:postal_code": {
                },
                "custom:city": {
                },
                "custom:company": {
                }
            },
        },
    },

    watch: {
        title() {
            this.titleComponent = this.title;
        },
        show() {
            this.showComponent = this.show;
            if(!this.show){
                // this.resetForm('updateUser');
                this.$v.$reset();
            }
        },
        color() {
            this.colorComponent = this.color;
        },
        size() {
            this.sizeComponent = this.size;
        },
        showComponent() {
            this.$emit("update:show", this.showComponent);
        },

        user() {
            this.forms.updateUser = this.user;
        },
    },

    methods: {
        closeModal() {
            this.showComponent = false;
        },

        async formSubmit(e, formName) {
            e.preventDefault();
            let response = await this.sendForm({
                formName,
                url: "/account.api/user/update",
                method: "PUT",
            });
            this.showComponent = false;

            this.$emit("submit", response);
        },

        executeSubmitForm(e) {
            this.$refs.formUpdateUser.requestSubmit();
        },
    },

    mounted() {
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;

        this.forms.updateUser = this.user;
    },
};
</script>

<style>
</style>